import { gql } from '@apollo/client';

export type QueryResult = {
  request: {
    id: string;
    profile: RequestProfile;
    employee: Employee;
  };
  clientSetting: ClientSetting;
};

type Profile = {
  id: string;
  isNotCoveredByNextYear: boolean;
  needAdjThisYear: boolean;
  nextYearOnly: boolean;
};

type RequestProfile = Profile & {
  formerJobs: FormerJob[];
};

type FormerJob = {
  id: string;
  withholdingSlipStatus: string;
};

type Employee = {
  id: string;
  status: string;
  profile: Profile;
};

type ClientSetting = {
  id: string;
  requestPrint: boolean;
};

export const ADJ_TARGET_FIELDS_FRAGMENT = gql`
  fragment AdjTargetFields on Profile {
    isNotCoveredByNextYear
    needAdjThisYear
    nextYearOnly
  }
`;

export const FETCH_FINISHED = gql`
  query finishedQuery {
    request {
      id
      profile {
        id
        ...AdjTargetFields
        formerJobs {
          id
          withholdingSlipStatus
        }
      }
      employee {
        id
        status
        profile {
          id
          ...AdjTargetFields
        }
      }
    }
    clientSetting {
      id
      requestPrint
    }
  }
  ${ADJ_TARGET_FIELDS_FRAGMENT}
`;
